export interface UserLicenseDto {
    subscriptionSeq: number;
    licenseCode: number;
    isActive: boolean;
    isSubscribing: boolean;
    startAt: string;
    nextRenewalAt: string;
}

export const InitialUserLicenseDto: UserLicenseDto = {
    subscriptionSeq: 0,
    licenseCode: 0,
    isActive: false,
    isSubscribing: false,
    startAt: "",
    nextRenewalAt: ""
}